export default __webpack_public_path__ + "static/media/line_green_tick.9bbd1fb5.svg";